import createBreakpoint from 'shared-tokens/utils/breakpoints';
import getExtPath from 'shared-utils/src/getExtPath';

export const mainCls = 'qrcode-container-flbck';
const brpM = createBreakpoint('m');

export default {
  [`${mainCls}`]: {
    display: 'none',
    [brpM]: {
      display: 'block',
      position: 'relative',
      zIndex: 1,
    }
  },
  [`${mainCls}__btnqr-fixed`]: {
    borderRadius: '0px 0px 4px 4px',
    borderRight: '1px solid #D8DBDF',
    borderBottom: '1px solid #D8DBDF',
    borderLeft: '1px solid #D8DBDF',
    borderTop: 'none',
    background: '#F8F9FA',
    padding: '8px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
};